import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 48, className }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className }) => (
  <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const MaskedInView = ({ children, delay = 0, className }) => (
  <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "115%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeStagger = ({ children, className, delay = 0 }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: 0.09, delayChildren: delay } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

export const FadeItem = ({ children, className }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y: 32 },
      show: { opacity: 1, y: 0, transition: { duration: 0.75, ease: EASE } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Equalizer = ({ className = "", barClass = "bg-[#4361ee]" }) => (
  <div className={`flex items-end gap-[3px] ${className}`} aria-hidden="true">
    {[0, 1, 2, 3].map((i) => (
      <span
        key={i}
        className={`eq-bar w-[3px] rounded-full ${barClass}`}
        style={{ height: `${14 + i * 5}px`, animationDelay: `${i * 0.18}s` }}
      />
    ))}
  </div>
);
